import axios from 'axios'
const WP_HOME = `https://members.eccourts.org`
import authService from '@/services/authService'

export const fetchNotifications = () => {
  return axios.get(`${WP_HOME}/wp-json/wp/v2/notifications?_fields=title,acf,id,date`)
}
export const getAppUsers = () => {
  
  const token = authService.getCookie("wcmCookie")
  return axios.get(`${WP_HOME}/wp-json/wp/v2/users?per_page=100&context=edit`, {
    headers:{
      Authorization:'Bearer'+token
    }
  })
}
export const getStatsCategories = () => {
  return axios.get(`${WP_HOME}/wp-json/wp/v2/categories?parent=176`)
}
export const getMySubmissions = (id) => {
  return axios.get(`${WP_HOME}/wp-json/wp/v2/statistics?author=${id}`)
}
export const getAllMySubmissions = () => {
  const token = authService.getCookie("wcmCookie")
  return axios.get(`${WP_HOME}/wp-json/wp/v2/statistics?per_page=100`, {
    headers:{
      Authorization:'Bearer'+token
    }
  })
}
export const fetchSubmission = (id) => {
  return axios.get(`${WP_HOME}/wp-json/wp/v2/statistics/${id}`)
}
export const updateSubmission = (id, data) => {
  const token = authService.getCookie("wcmCookie")
  if(!id) return axios.post(`${WP_HOME}/wp-json/wp/v2/statistics`, data, {
    headers:{
    "Authorization": 'Bearer'+token 
    }
  }) 
  else {
    return axios.post(`${WP_HOME}/wp-json/wp/v2/statistics/${id}`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    }) 
  }
}
export default {
  get(slug) {
    return axios.get(`${WP_HOME}/wp-json/wp/v2/posts/?slug=${slug}`);
  },
  getById(id) {
    return axios.get(`${WP_HOME}/wp-json/wp/v2/posts/${id}`);
  },
  getByType(type){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/${type}`)
  },
  getByTypeAndId(type, id){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/${type}/${id}`)
  },
  getByTypeAndSlug(type, slug){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/${type}?slug=${slug}`)
  },
  getNavItems (id) {
    return axios.get(`${WP_HOME}/wp-json/menus/v1/menus/${id}`)
  },
  async getCategory(slug){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/categories?slug=${slug}`)
  },
  getCategoryChildren(id){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/categories?parent=${id}`)
  },
  async getCategoryByID(id){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/categories/${id}`)
  },
  getCategoryPosts(id){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/posts?categories=${id}`)
  },
  getSearchResults(query){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/transcripts?search=${query}`)
  },
  getRecordsUsers(){
    return axios.get(`${WP_HOME}/wp-json/acf/v3/rus?per_page=400`)
  },
  getTranscripts ({q}) {
    let pagination = q ? q : {page:1, per_page: 12}
    return axios.get(`${WP_HOME}/wp-json/wp/v2/transcripts?per_page=${pagination.per_page}&page=${pagination.page}`)
  },
  getTranscript (id) {
    return axios.get(`${WP_HOME}/wp-json/wp/v2/transcripts/${id}`)
  },
  getRecordsCompanies(){
    return axios.get(`${WP_HOME}/wp-json/wp/v2/companies?per_page=100`)
  },
  saveCompanyRecord(data){
    const token = authService.getCookie("wcmCookie")
    return axios.post(`${WP_HOME}/wp-json/wp/v2/companies/`,data,{
      headers:{
        "Authorization": 'Bearer'+token 
        }
    })
  },
  saveRecordUser(data){
    const token = authService.getCookie("wcmCookie")
    return axios.post(`${WP_HOME}/wp-json/wp/v2/rus`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  getLibraryEntries ({q}) {
    let pagination = q ? q : {page:1, per_page: 12}
    const token = authService.getCookie("wcmCookie")
    return axios.get(`${WP_HOME}/wp-json/wp/v2/library_entries?per_page=${pagination.per_page}&page=${pagination.page}`,{
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  getSingleEntry (id) {
    return axios.get(`${WP_HOME}/wp-json/wp/v2/library_entries/${id}`)
  },
  saveLibraryEntries (data) {
    const token = authService.getCookie("wcmCookie")
    return axios.post(`${WP_HOME}/wp-json/wp/v2/library_entries`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  
  deleteEntry(id){
    const token = authService.getCookie("wcmCookie")
    return axios.delete(`${WP_HOME}/wp-json/wp/v2/library_entries/${id}`, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  getSingleRecord (id){
    const token = authService.getCookie("wcmCookie")
    return axios.get(`${WP_HOME}/wp-json/wp/v2/records/${id}`, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  getRecords(params){
    let per_page = ''
    let page = ''
    if (params)  {
      per_page = params['per_page']
      page = params['page']
    } else {
      per_page = 100
      page = 1
    }
    const token = authService.getCookie("wcmCookie")
    return axios.get(`${WP_HOME}/wp-json/wp/v2/records?status=publish,draft&_fields=id,slug,title,acf,content,excerpt,date,modified&page=${page}&per_page=${per_page}&order=desc`,{
      headers:{
        "Authorization": 'Bearer'+token 
        }
    })
  },
  checkMostRecentRecord(){
    const token = authService.getCookie('wcmCookie')
    return axios.get(`${WP_HOME}/wp-json/wp/v2/records?status=publish,draft&_fields=id,acf&per_page=1&order=desc`,{
      headers:{
        "Authorization": 'Bearer'+token 
        }
    })
  },
  saveRecord(data){
    const token = authService.getCookie("wcmCookie")
    return axios.post(`${WP_HOME}/wp-json/wp/v2/records`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  saveTranscript (data) {
    const token = authService.getCookie("wcmCookie")
    return axios.post(`${WP_HOME}/wp-json/wp/v2/transcripts`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  updateTranscript (data, id) {
    const token = authService.getCookie("wcmCookie")
    return axios.post(`${WP_HOME}/wp-json/wp/v2/transcripts/${id}`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  updateRecord(data, id){
    const token =  authService.getCookie('wcmCookie')
    return axios.post(`${WP_HOME}/wp-json/wp/v2/records/${id}`, data,{
      headers:{
        "Authorization":'Bearer'+token
      }
    })
  },
  deleteTranscript(id){
    const token = authService.getCookie("wcmCookie")
    return axios.delete(`${WP_HOME}/wp-json/wp/v2/transcripts/${id}`, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  deleteRecord(id){
    const token = authService.getCookie("wcmCookie")
    return axios.delete(`${WP_HOME}/wp-json/wp/v2/records/${id}`, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  saveForms(data) {
    const token =  authService.getCookie('wcmCookie')
    return axios.post(`${WP_HOME}/wp-json/wp/v2/forms/`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  getForms({page, per, author}) {
    const token =  authService.getCookie('wcmCookie')
    let url = author 
              ? `${WP_HOME}/wp-json/wp/v2/forms?per_page=${per}&page=${page}&author=${author}`
              : `${WP_HOME}/wp-json/wp/v2/forms?per_page=${per}&page=${page}`
    return axios.get(url, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  getForm({id}) {
    const token =  authService.getCookie('wcmCookie')
    return axios.get(`${WP_HOME}/wp-json/wp/v2/forms/${id}`, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  updateForms(data, id) {
    const token =  authService.getCookie('wcmCookie')
    return axios.post(`${WP_HOME}/wp-json/wp/v2/forms/${id}`, data, {
      headers:{
      "Authorization": 'Bearer'+token 
      }
    })
  },
  uploadFile(file, config){
    const token = authService.getCookie("wcmCookie")
    let formData = new FormData()
    formData.append('file', file)
    return axios.post(`${ WP_HOME}/wp-json/wp/v2/media`,formData,
    {
      onUploadProgress(e){
       config
       ? config(e)
       : ''
       // console.log(`e.loaded: ${e.loaded}, e.total: ${e.total}, percent: ${(e.loaded / e.total ) * 100}`); 
      },
      headers:{
        "Authorization": 'Bearer'+token,
        'Content-Type': 'multipart/form-data',
      }
    })
  }
}